// Copy for actions the demo workspace turns off (DemoGuard on the API).
// Shown as a reason beside a disabled control, or once as an info toast.
export const DEMO_CALLING_OFF = "Calling is off in this demo workspace.";
